module.exports = "<span>\n  <input type=\"radio\" [checked]=\"gmtChecked\" [disabled]=\"gmtDisabled\" (change)=\"onChanged()\"/>\n  <span></span>\n</span>\n"